import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Heart } from "lucide-react";
import { api, apiError } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { toast } from "sonner";

export default function Looks() {
  const { data: wishlist, error: wishErr, isLoading } = useQuery({
    queryKey: ["wishlist"],
    queryFn: async () => (await api.get("/wishlist", { timeout: 20000 })).data,
  });

  useEffect(() => {
    if (wishErr) toast.error(apiError(wishErr));
  }, [wishErr]);

  const wishItems = wishlist?.products || [];

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="flex items-center gap-2 text-[11px] tracking-luxe uppercase text-aura-cyan mb-3">
        <Heart className="w-3.5 h-3.5" /> Saved
      </div>
      <h1 className="font-serif text-5xl font-extrabold tracking-tight mb-3">Saved pieces</h1>
      <p className="text-sm text-aura-muted max-w-lg mb-12">
        Heart an item while you shop. It shows up here so you can open it again.
      </p>

      {isLoading ? (
        <div className="py-12 text-center text-aura-muted">Loading saved pieces…</div>
      ) : wishItems.length === 0 ? (
        <div className="py-12 text-center text-aura-muted border border-dashed border-aura-border rounded-xl">
          Nothing saved yet. Tap the <Heart className="w-4 h-4 inline -mt-1" /> on any product.
          <div className="mt-4"><Link to="/shop" className="link-underline text-aura-cyan">Browse the shop →</Link></div>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-testid="wishlist-grid">
          {wishItems.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
